import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { TCreatePrePurchaseForm } from './create-pre-purchase.schema';

const PrePurchaseItemsFieldArrayContext = createContext<ReturnType<
    typeof usePrePurchaseItemsFieldArray
> | null>(null);

function usePrePurchaseItemsFieldArray() {
    const { control } = useFormContext<TCreatePrePurchaseForm>();

    return useFieldArray({ control, name: 'items' });
}

export const PrePurchaseItemsFieldArrayProvider: FC<PropsWithChildren> = ({
    children,
}) => {
    const fieldArray = usePrePurchaseItemsFieldArray();

    return (
        <PrePurchaseItemsFieldArrayContext.Provider value={fieldArray}>
            {children}
        </PrePurchaseItemsFieldArrayContext.Provider>
    );
};

export const usePrePurchaseItemsFieldArrayContext = () => {
    const context = useContext(PrePurchaseItemsFieldArrayContext);

    if (!context) {
        throw new Error(
            'usePrePurchaseItemsFieldArrayContext must be used within PrePurchaseItemsFieldArrayProvider',
        );
    }

    return context;
};
